import update from 'immutability-helper';

// Creates a reducer managing pagination, given the action types to handle,
// and a function telling how to extract the key from an action.
const paginate = ({ types, mapActionToKey, appendResults = false }) => {
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected types to be an array of three elements.');
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.');
	}
	if (typeof mapActionToKey !== 'function') {
		throw new Error('Expected mapActionToKey to be a function.');
	}

	const [requestType, successType, failureType] = types;

	const initialState = {
		loading: false,
		filter: {},
		sortKey: '',
		sortDirection: '',
		pageSize: 10,
		pageNumber: 1,
		pages: 0,
		total: 0,
		ids: []
	};
	const updatePagination = (state = initialState, action) => {
		switch (action.type) {
			case requestType:
				const { sortKey, sortDirection, pageSize, pageNumber, ...filter } = action.payload;
				return update(state, {
					loading: { $set: true },
					filter: { $set: filter },
					sortKey: { $set: sortKey },
					sortDirection: { $set: sortDirection },
					pageSize: { $set: pageSize },
					pageNumber: { $set: pageNumber }
				});
			case successType:
				let resultIds = action.response.result ? (action.resultIds ? action.resultIds(action.response.result) : action.response.result) : [];
				// remove duplicates if appending results
				if (appendResults) {
					const idsSet = new Set(state.ids);
					resultIds.forEach(id => idsSet.add(id));
					resultIds = [...idsSet];
				}
				return update(state, {
					loading: { $set: false },
					ids: { $set: resultIds },
					total: { $set: action.response.totalCount },
					pages: { $set: Math.ceil(action.response.totalCount / state.pageSize) }
				});
			case failureType:
				return update(state, {
					loading: { $set: false }
				});			
			default:
				return state;
		}
	};

	return (state = {}, action) => {
		// Update pagination by key
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:			
				const key = mapActionToKey(action);
				if (typeof key !== 'string') {
					throw new Error('Expected key to be a string.');
				}
				return update(state, {
					[key]: { $set: updatePagination(state[key], action) }
				});
			case 'LOGIN_SUCCESS':				
				return {};
			default:
				return state;
		}
	};
};

export default paginate;